const getUrl = () => {
  return `${process.env.REACT_APP_API_URL}/seguridad`
}

const LogIn = async (dataRequest) => {
  return await fetch(`${getUrl()}/login/auth`, {
    method: 'POST',
    body: JSON.stringify(dataRequest),
    mode: 'cors',
    cache: 'default',    
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    //credentials: 'include' // Importante para enviar cookies (si es necesario)
  }).then(async (result) => {
    if (!result.ok) {
      throw Error(`Error status (${result.status.toString()}) ${result.statusText}`)
    } else {
      return await result.json()
    }
  })
    .catch(error => {
      console.error('Error API: ', error.message)
      return
    })
}

const ChangePassword = async (dataRequest) => {
  return await fetch(`${getUrl()}/login/changePassword`, {
    method: 'POST',
    body: JSON.stringify(dataRequest),
    mode: 'cors',
    cache: 'default',
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    //credentials: 'include' // Importante para enviar cookies (si es necesario)
  }).then(async (result) => {
    if (!result.ok) {
      throw Error(`Error status (${result.status.toString()}) ${result.statusText}`)
    } else {
      return await result.json()
    }
  })
    .catch(error => {
      console.error('Error API: ', error.message)
      return
    })
}

const requestApi = {
  LogIn,
  ChangePassword
}

export default requestApi;